import { render } from "./headerFeven.vue?vue&type=template&id=4a912431&scoped=true&ts=true"
import script from "./headerFeven.vue?vue&type=script&lang=ts"
export * from "./headerFeven.vue?vue&type=script&lang=ts"

import "./headerFeven.vue?vue&type=style&index=0&id=4a912431&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a912431"]])

export default __exports__